import type {
	HTTPValidationError,
	SavedFilterCreateModel,
	SavedFilterModel,
	SavedFilterUpdateModel,
} from '@/shared/generated'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { useMutation } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export function useCreateSavedFilterMutation(
	options?: UseMutationOptions<
		SavedFilterModel,
		AxiosError<HTTPValidationError>,
		SavedFilterCreateModel
	>
) {
	return useMutation<
		SavedFilterModel,
		AxiosError<HTTPValidationError>,
		SavedFilterCreateModel
	>({
		mutationFn: (payload) => client.savedFilters.createSavedFilter(payload),
		...(options || {}),
	})
}

export function useUpdateSavedFilterMutation(
	savedFilterId: string,
	options?: UseMutationOptions<
		SavedFilterModel,
		AxiosError<HTTPValidationError>,
		SavedFilterUpdateModel
	>
) {
	return useMutation<
		SavedFilterModel,
		AxiosError<HTTPValidationError>,
		SavedFilterUpdateModel
	>({
		mutationFn: (payload) =>
			client.savedFilters.updateSavedFilter({ savedFilterId }, payload),
		...(options || {}),
	})
}
export function useDeleteSavedFilterMutation(
	options?: UseMutationOptions<void, AxiosError<HTTPValidationError>, string>
) {
	return useMutation<void, AxiosError<HTTPValidationError>, string>({
		mutationFn: (savedFilterId) =>
			client.savedFilters.deleteSavedFilter({ savedFilterId }),
		...(options || {}),
	})
}
